// extracted by mini-css-extract-plugin
export default {"button":"HelpPane_button__JA-6Q","pane":"HelpPane_pane__3msM6"};